module.exports = __webpack_public_path__ + "img/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.212268cf.png";